// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-list[data-v-30547438]{height:100%;overflow:auto;padding-left:5px;padding-top:8px}.img-msg[data-v-30547438]{border-radius:50%;width:50px;margin-right:5px}.user-element[data-v-30547438]{font-size:20px;vertical-align:middle}", ""]);
// Exports
module.exports = exports;
